import awardImage01 from "@assets/awards/static-award.png";
import blurredCouponImage from "@assets/awards/blurred-coupon.png";
import NiceModal from "@ebay/nice-modal-react";
export const UNBRADED_URLS = [
  "/logout",
  // "/404",
  "/age-gate",
  "/age-gate-failed",
  "/maintenance",
  "/welcom-screen",
];

export const levelMapper = new Map([
  [1, "Einsteiger"],
  [2, "Profi"],
  [3, "Experte"],
]);

export const staticCoupon = {
  ident: "static",
  content: {
    title: "<strong>Ultra</strong>Experience - Berlin P61",
    description: "glo™ Hard Carry Case",
  },
  thumbnail: {
    file: {
      url: awardImage01,
    },
  },
  hero_image: {
    file: {
      url: awardImage01,
    },
    metadata: {
      imgDesc: "Berlin P61",
    },
  },
  highlighted: true,
  price: 0,
  hasLevel: true,
  level: 1,
  inStock: true,
  hasPoints: true,
  partner: false,
  onClick: () => {
    NiceModal.show("static-award-modal");
  },
};

export const FORCE_SKIN_ID = "mclaren2025";
export const FORCE_SKIN_END = new Date("2025-12-12T23:59:59Z");

export const BLURRED_COUPON_IDENTS = [
  "rituals_15_happy_monday_20260921",
  "vuse-10_percent_happy_monday_20260921",
  "eventim_10_happy_monday_20260928",
  "bloom_10_happy_monday_20261012",
  "mydays_10_happy_monday_20261019",
  "gourmetfleisch_10_happy_monday_20261026",
  "rituals_15_happy_monday_20261102",
  "adidas_10_happy_monday_20261109",
];
export const BLURRED_COUPON_IMAGE = blurredCouponImage;

export function isBlurredCouponIdent(ident) {
  return BLURRED_COUPON_IDENTS.includes(ident);
}
